const getUserPreferredLlmProvider = (rawPreferences: unknown): string => {
  try {
    const parsed: unknown =
      typeof rawPreferences === "string" ? (JSON.parse(rawPreferences) as unknown) : rawPreferences;

    const rawPref =
      parsed && typeof parsed === "object" && "preferredLlmProvider" in parsed
        ? (parsed as Record<string, unknown>).preferredLlmProvider
        : null;

    const pref = typeof rawPref === "string" ? rawPref.toLowerCase() : "mistral";

    return pref === "mistral" ? "mistral" : "openai";
  } catch {
    return "mistral";
  }
};

export default getUserPreferredLlmProvider;
